import Resources from "shared/actions/resourcesActions";

// eslint-disable-next-line import/prefer-default-export
export class DocumentationItemsResource extends Resources {
  constructor(dispatch) {
    super(dispatch, "documentation_item", `/api/v1/documentation_items`);
  }
}
